import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./buyhouse.css"; // reuse same CSS
import API from "../../../api";
import { Phone, MessageCircle, Mail } from "lucide-react";

function BuyLand() {
  const navigate = useNavigate();

  const [lands, setLands] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FILTER STATES ================= */
  const [search, setSearch] = useState("");
  const [location, setLocation] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [approvalType, setApprovalType] = useState("");
  const [loanAvailable, setLoanAvailable] = useState("");
  const [sort, setSort] = useState("latest");
  const [showConsult, setShowConsult] = useState(false);
const [consultUser, setConsultUser] = useState(null);

  const user = JSON.parse(localStorage.getItem("civilink_user"));

  /* ================= FETCH LANDS ================= */
  const fetchLands = async () => {
    setLoading(true);

    const params = new URLSearchParams();

    if (search) params.append("q", search);
    if (location) params.append("location", location);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (approvalType) params.append("approvalType", approvalType);
    if (loanAvailable) params.append("loanAvailable", loanAvailable);
    if (sort) params.append("sort", sort);

    const res = await fetch(
      `/api/land/buy?${params.toString()}`
    );

    const data = await res.json();

    if (data.success) {
      setLands(data.lands);
    } else {
      setLands([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchLands();
  }, []);

  /* ================= CONTACT SELLER ================= */
  const contactSeller = (seller) => {
    
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  setConsultUser(seller);
  setShowConsult(true);
};

  const resetFilters = () => {
    setSearch("");
    setLocation("");
    setMinPrice("");
    setMaxPrice("");
    setApprovalType("");
    setLoanAvailable("");
    setSort("latest");
    fetchLands();
  };

  return (
    <div className="buyhouse-page">

      {/* ================= FILTER BAR ================= */}
      <div className="buyhouse-filters">
        <input
          placeholder="Search land or layout"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <input
          placeholder="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />

        <input
          type="number"
          placeholder="Min Price"
          value={minPrice}
          onChange={(e) => setMinPrice(e.target.value)}
        />

        <input
          type="number"
          placeholder="Max Price"
          value={maxPrice}
          onChange={(e) => setMaxPrice(e.target.value)}
        />

        <select
          value={approvalType}
          onChange={(e) => setApprovalType(e.target.value)}
        >
          <option value="">All Approvals</option>
          <option value="DTCP">DTCP</option>
          <option value="CMDA">CMDA</option>
          <option value="Panchayat">Panchayat</option>
        </select>

        <select
          value={loanAvailable}
          onChange={(e) => setLoanAvailable(e.target.value)}
        >
          <option value="">Loan</option>
          <option value="yes">Loan Available</option>
          <option value="no">No Loan</option>
        </select>

        <select value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="latest">Latest</option>
          <option value="priceLow">Price: Low → High</option>
          <option value="priceHigh">Price: High → Low</option>
        </select>

        <button className="filter-btn" onClick={fetchLands}>
          Apply
        </button>

        <button className="reset-btn" onClick={resetFilters}>
          Reset
        </button>
      </div>

      {/* ================= CONTENT ================= */}
      {loading ? (
        <div className="buyhouse-loading">Loading lands…</div>
      ) : lands.length === 0 ? (
        <div className="buyhouse-empty">No lands found</div>
      ) : (
        <div className="buyhouse-list">
          {lands.map((l) => (
            <div key={l._id} className="buyhouse-card">

              {l.layoutImageUrl && (
                <img
                  src={l.layoutImageUrl}
                  alt="Land"
                  className="buyhouse-image"
                />
              )}

              <div className="buyhouse-info">
                <h4>{l.title}</h4>
                <p className="location">
                  📍 {l.location?.city}, {l.location?.state}
                </p>
                <p className="price">
                  ₹{Number(l.price).toLocaleString("en-IN")}
                </p>
              </div>

              <button
  className="contact-btn"
  onClick={() => {
    
    contactSeller(l.postedBy);
  }}
>
  Contact Seller
</button>
            </div>
          ))}
        </div>
      )}

      {showConsult && (
        <div
          className="customer-sheet-overlay"
          onClick={() => setShowConsult(false)}
        >
          <div
            className="customer-sheet"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sheet-handle" />
      
            <h3 className="sheet-title">
              Contact Professional
            </h3>
      
            <p className="sheet-subtitle">
              Choose how you'd like to connect.
            </p>
      
            {consultUser?.phone && (
              <>
                <button
                  className="sheet-btn primary"
                  onClick={() => {
                    window.location.href = `tel:${consultUser.phone}`;
                    setShowConsult(false);
                  }}
                >
                  <Phone size={18} />
                  <span>Call</span>
                </button>
      
                <button
                  className="sheet-btn primary"
                  onClick={() => {
                    const text = encodeURIComponent(
                      `Hello ${consultUser.name},
      
      I found your profile on Civilink and would like to discuss my construction requirements.`
                    );
      
                    window.open(
                      `https://wa.me/91${consultUser.phone}?text=${text}`,
                      "_blank"
                    );
      
                    setShowConsult(false);
                  }}
                >
                  <MessageCircle size={18} />
                  <span>WhatsApp</span>
                </button>
              </>
            )}
      
            {consultUser?.email && (
              <button
                className="sheet-btn primary"
                onClick={() => {
                  window.location.href = `mailto:${consultUser.email}?subject=Construction Inquiry from Civilink`;
                  setShowConsult(false);
                }}
              >
                <Mail size={18} />
                <span>Email</span>
              </button>
            )}
      
            {!consultUser?.phone && !consultUser?.email && (
              <div className="contact-unavailable">
                Contact information not available.
              </div>
            )}
      
            <button
              className="sheet-btn outline"
              onClick={() => setShowConsult(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default BuyLand;
